// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1trWx","title":"AfterFrontImage_title__CN9bq"};